import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews, ReviewRating, AvatarSmall } from '../../components';
import moment from 'moment'

import css from './ListingPage.module.css';

const SectionReviews = props => {
  const { reviews, fetchReviewsError } = props;

  const averageRating = reviews.reduce((sum, r) => sum + r?.attributes?.rating, 0) / reviews.length;
  const rounded = Math.round(averageRating);

  const TimePartOfLlivio = ({ createdAt }) => {
    const joined = moment(createdAt);
    const now = moment();

    const years = now.diff(joined, 'years');
    joined.add(years, 'years');

    const months = now.diff(joined, 'months');
    joined.add(months, 'months');

    const days = now.diff(joined, 'days');

    let display = '';

    if (years > 0) {
      display = `${years} ${years === 1 ? 'Year' : 'Years'}`;
    } else if (months > 0) {
      display = `${months} ${months === 1 ? 'Month' : 'Months'}`;
    } else {
      // Includes the case where all are 0, meaning today
      display = `${days === 0 ? 1 : days} ${days === 1 ? 'Day' : 'Days'}`;
    }

    return <span>{display} part of Llivio</span>;
  };

  return (
    <>
      { reviews?.length > 0 &&
        <section className={css.sectionReviews}>
          <div className={css.reviewHeadingBox}>
            <div className={css.ratingCount}>
              <div className={css.ratingNum}>{averageRating}</div>
              <div className={css.ratingStar}>
                <ReviewRating
                  rating={rounded}
                />
              </div>
            </div>
            <div className={css.reviewBox}>
              <div className={css.reviewNum}>{ reviews?.length }</div>
              <div className={css.reviewText}>Reviews</div>
            </div>
          </div>
          {fetchReviewsError ? (
            <H2 className={css.errorText}>
              <FormattedMessage id="ListingPage.reviewsError" />
            </H2>
          ) : null}

          <div className={css.reviewRow}>
            {reviews?.map((review)=>(
              <div className={css.reviewBox}>
                <div className={css.userBox}>
                  <AvatarSmall user={ review?.author} className={css.userImage} />
                  {/*<img src="https://static.thenounproject.com/png/5100711-200.png" alt="user-img" className={css.userImage} />*/}
                  <div className={css.userDetails}>
                    <div className={css.userName}>{review?.author?.attributes?.profile?.displayName}</div>
                    <div className={css.reviewTime}><TimePartOfLlivio createdAt={review?.author?.attributes?.createdAt} /></div>
                  </div>
                </div>
                <div className={css.reviewText}>{review?.attributes?.content}</div>
              </div>
            ))}
          </div>

          {/*<Reviews reviews={reviews} />*/}
        </section>
      }
    </>
  );
};

export default SectionReviews;
